import { TimezoneType } from '@wix/bookings-uou-types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getUoULocale } from '../utils/locale/locale';
import { BusinessInfo } from '../../legacy/types';
import { isAnywhereFlow } from '../utils/anywhere/anywhere';
import {
  getLanguage,
  getLocale,
} from '@wix/bookings-catalog-calendar-viewer-utils';
import { ViewMode } from '../types/types';
import {
  BasedOn,
  BookingsSettings,
} from '@wix/ambassador-bookings-v2-bookings-settings/types';

export type ServiceListContext = {
  isPricingPlanInstalled: boolean;
  isAnywhereFlow: boolean;
  businessInfo: BusinessInfo;
  viewMode: ViewMode;
  bookingsSettings: BookingsSettings;
};

type CreateServiceListContextParams = {
  bookingsSettings: BookingsSettings;
  flowAPI: ControllerFlowAPI;
  isPricingPlanInstalled: boolean;
  viewMode: ViewMode;
};

export const createServiceListContext = async ({
  flowAPI,
  bookingsSettings,
  isPricingPlanInstalled,
  viewMode,
}: CreateServiceListContextParams): Promise<ServiceListContext> => {
  const {
    environment: { isPreview },
    controllerConfig: { wixCodeApi },
  } = flowAPI;
  const businessInfo = mapBookingsSettingsToBusinessInfo(bookingsSettings);

  businessInfo.language = getLanguage(wixCodeApi);
  businessInfo.regionalSettings = getLocale(wixCodeApi);

  const isAnywhereFlowInd = await isAnywhereFlow(wixCodeApi, isPreview);

  return {
    isPricingPlanInstalled,
    isAnywhereFlow: isAnywhereFlowInd,
    businessInfo,
    viewMode,
    bookingsSettings,
  };
};

const mapBookingsSettingsToBusinessInfo = (
  bookingsSettings: BookingsSettings,
): BusinessInfo => {
  const { siteProperties, displayTimeZone } = bookingsSettings;
  const timezoneProperties = {
    defaultTimezone:
      displayTimeZone?.basedOn === BasedOn.CUSTOMER_TIME_ZONE
        ? TimezoneType.CLIENT
        : TimezoneType.BUSINESS,
  };
  const { businessName, language, timeZone, locale } = siteProperties!;

  return {
    language: getUoULocale(language || ''),
    name: businessName!,
    regionalSettings: locale?.country!,
    timeZone: timeZone!,
    timezoneProperties,
  };
};
